import React, { useEffect, useMemo, useState } from "react";
import {
  HeaderListComponent,
  PageListComponent,
  ListComponent,
  DatePickerComponent,
} from "../../../common/component/Index";
import Wrapper from "../../../common/component/Wrapper";
import Button from "../../../common/component/Button";
import {
  columnsTableName,
  getDataSource,
  getTitleTable,
  capitalizeFirstLetter,
  genarateFilter,
  getPermissionActions
} from "../../../../../helpers/functions";
import DEFINE, { DATE_TIME_FORMAT } from "../../../../../constants/Define";
import { omit } from "lodash";
import "./BtbUseRoomReport.less";
import moment from 'moment';
import RenderHotelisActive from '../../Hotels/HotelList/RenderHotelisActive';
import { message } from 'antd';

const BtbUseRoomReport = (props) => {
  const { getBtbUseRoomReport, btbUseRoomState, loadingBtbUseRoom, t, getExportBtbUseRoomReport, isFetchingExportBtbUseRoom } = props;
  const [flatData, setFlatData] = useState([]);
  const [reportListCols, setReportListCols] = useState([]);

  useEffect(() => {
    if (btbUseRoomState && Array.isArray(btbUseRoomState.items)) {
      const flattenData = [];
      const columns = ['Date'];
      btbUseRoomState.items.forEach(item => {
        const date = item.date;
          if (date === "0001-01-01T00:00:00") {
              columns.pop();
          return;
        }
        const row = { Date: date };
        item.detailRoomType.forEach((room, index) => {
          const roomColumn = `${room.roomTypeCode}`;
          if (!columns.includes(roomColumn)) {
            columns.push(roomColumn);
          }
          row[roomColumn] = `${room.soldCount}/${room.hardblock}`;
        });
        flattenData.push(row);
      });
      setFlatData(flattenData);
      setReportListCols(columns);
    }
  }, [btbUseRoomState]);
  const titleItemTable = useMemo(() => getTitleTable(reportListCols, [], []), [reportListCols]);

  const componentTable = useMemo(() => {
    const tableColumns = {
      Date: {
        key: "Date",
        width: 150,
        render: (Date) => moment(Date).format(DATE_TIME_FORMAT.SHORT_DATE)
      },
    };

    reportListCols.forEach(col => {
      if (col !== 'Date') {
        tableColumns[col] = {
          key: col,
          width: 100,
        };
      }
    });

    return tableColumns;
  }, [reportListCols]);

  const permisionActions = useMemo(() => getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.BTB_USE_ROOM_REPORT), []);
  const [filter, setFilter] = useState({});
  const [checkedItem, setCheckedItem] = useState([]);
  const filterBtbUseRoomReport = (filters) => {
    if (!filters) {
      filters = omit(btbUseRoomState, ["items"]);
    }
    setFilter(filters);
    getBtbUseRoomReport(filters);
  };

  const onExportExcel = () => {
    getExportBtbUseRoomReport(filter);
  };

  useEffect(() => {
    filterBtbUseRoomReport();
  }, []);

  const onTableChange = (filters) => {
    let newFilter = genarateFilter(filters);
    newFilter.startDate = filter.startDate;
    newFilter.endDate = filter.endDate;
    filterBtbUseRoomReport(newFilter)
  };

  const onSelectDateRange = (data) => {
    const newFilter = { ...filter };
    newFilter.startDate = data.fullValue[0];
      newFilter.endDate = data.fullValue[1];
      if (moment(newFilter.endDate).diff(moment(newFilter.startDate), 'days') > 30) {
          message.error(t('validation.queryWithTime30Days'));
          return;
      }
    filterBtbUseRoomReport(newFilter);
  };

  const onChangeHotel = (hotelId) => {
      if (hotelId) {
          const newFilter = { ...filter, hotelId };
          filterBtbUseRoomReport(newFilter);
      }
  };

  const CustomButton = ({ onPress = () => {}, title = "", disabled = false, loading = false }) => {
    return (
      <Button
        type="primary"
        onClick={onPress}
        icon="download"
        loading={loading}
        className="mr-2 height-btn"
        disabled={!permisionActions.allowExportFileExcel}
      >
        {title}
      </Button>
    );
  };

  return (
    <Wrapper className="col-md-12 p-0 mt-3 report-list">
      
        <PageListComponent className="cash-flow-detail-page">
          <HeaderListComponent
            path={props.match.path}
            groupPath={"cashFlow"}
            titleHeader={capitalizeFirstLetter(
              `${t("item.btbUseRoomReport.title")}`
            )}
          />
          {
           permisionActions.allowView && 
           <>
            <Wrapper className={`d-flex row`}>
              <Wrapper className="col-6">
                <Wrapper className="row">
                <Wrapper className={`flex col-12`}>
                    <RenderHotelisActive
                      onChangedHotel={onChangeHotel}
                      isBeachVilla={true}
                      isActive = {null}
                    />
                    <DatePickerComponent
                        className={`form-control applyDates col-6 align-items-end`}
                        hmsComponent={`RangePicker`}
                        format={DATE_TIME_FORMAT.SHORT_DATE}
                        style={{ padding: 0, border: 0 }}
                        onChange={onSelectDateRange}
                        name={`applyDates`}
                        placeholder={[
                            t("placeHolderForm.startDate"),
                            t("placeHolderForm.endDate"),
                        ]}
                        value={[filter?.startDate, filter?.endDate]}
                    />
                    <div className={`col-2`}>
                        <CustomButton
                            onPress={onExportExcel}
                            title={t(`item.btbUseRoomReport.export`)}
                            loading={isFetchingExportBtbUseRoom}
                        />
                    </div>
                    
                </Wrapper>
                </Wrapper>
              </Wrapper>
            </Wrapper>
            <Wrapper className={`mt-3`}>
              <ListComponent
                className="cash-flow-report"
                tableKey="sale-report-list"
                classParent="m-0 p-0"
                marginTop={"0"}
                marginBottom={"0"}
                // scroll={{ x: 4200 }}
                scroll={{ x: 'max-content' }}
                tableLayout='auto'
                loading={{ spinning: loadingBtbUseRoom, size: "large" }}
                rowKey={(record, k) => record.id}
                dataSource={getDataSource(
                  flatData || [],
                  reportListCols
                )}
                columns={columnsTableName({
                  titleTable: titleItemTable,
                  component: componentTable,
                  itemName: "btbUseRoomReport",
                })}
                onChange={onTableChange}
                componentTableList={{}}
              />
            </Wrapper>
           </>
          }
        </PageListComponent>
    </Wrapper>
  );
};

export default BtbUseRoomReport;
